<span class="text-sm font-normal text-widget sm:text-xs" [class.truncate]="!enableListMultiline"
      [style.overflow-wrap]="enableListMultiline ? 'anywhere' : null"
      [style.text-wrap]="enableListMultiline ? 'pretty' : null">
      @switch(column.GridColumnType) {
        @case(GridColumnType.Date) {
          {{ format() | date }}
        }
        @case(GridColumnType.DateTime) {
          {{ format() | datetime }}
        }
        @case(GridColumnType.Time) {
          {{ format() | time }}
        }
      }
</span>
